import { createContext, useContext, useEffect, useState } from "react";
import { getApp, initializeApp } from "firebase/app";
import { getAuth, signInWithCustomToken } from "firebase/auth";
import { getFirestore, collection, onSnapshot, query, where, orderBy, doc, getDoc, limit, setDoc, addDoc, getDocs, deleteDoc } from 'firebase/firestore'
import { connectFunctionsEmulator, getFunctions, httpsCallable } from 'firebase/functions'
import { getStorage, ref, getDownloadURL, uploadBytes } from 'firebase/storage'

import { Frame, Toast } from '@shopify/polaris'

import { useQuery } from "@tanstack/react-query";

export const PartnerUpContext = createContext({});
export const usePartnerUp = () => useContext(PartnerUpContext);

let firebaseConfig;
let isProduction = process.env.NODE_ENV === 'production';

if (isProduction) {
  firebaseConfig = {
    apiKey: "AIzaSyBnzqjZt_UcLjY6wpdUEfIk0yZybzKG3L4",
    authDomain: "auth.partnerup.net",
    projectId: "partner-up-prod",
    storageBucket: "partner-up-prod.appspot.com",
    messagingSenderId: "1033616837777",
    appId: "1:1033616837777:web:d2d3c67bf2585465890330"
  };
  // STRIPE_PUBLIC_KEY = 'pk_live_51NE8qjA8I6Mhcszp6f5GBLr6eFO9KrHOgRLeS5ZzWrwzyEJIhJDkkQS13N9uG2ILPEw6QaMR7ZU6jCehg4zbRTaV00JiSGcSJK'
} else {
  firebaseConfig = {
    apiKey: "AIzaSyBSiltELmJ0XtZ7tQYE6-Z1Eur4cyGmNIc",
    authDomain: "partner-up-staging.firebaseapp.com",
    projectId: "partner-up-staging",
    storageBucket: "partner-up-staging.appspot.com",
    messagingSenderId: "269501289751",
    appId: "1:269501289751:web:92c2d0ed06f1fb512f5352"
  };
  // STRIPE_PUBLIC_KEY = 'pk_test_51NE8qjA8I6Mhcszp01dFjVUJMuVxyD7AzaMDmPNNqaYLqSvkynEbQHQudfgYJDaHYmm9cYRCR0tk58XSVerEJ0Va006wphrqNo'
}

initializeApp(firebaseConfig);

const functions = getFunctions(getApp())
/*
if (process.env.NODE_ENV === 'development') {
  connectFunctionsEmulator(functions, "localhost", 5001);
}
*/

const db = getFirestore();
const auth = getAuth();

const getModashProfile = httpsCallable(functions, 'getModashProfileV2');


export default function PartnerUpWebProvider({ children }) {

  const [authReady, setAuthReady] = useState(false);
  const [outreachInvites, setOutreachInvites] = useState([]);
  const [deals, setDeals] = useState([]);
  const [content, setContent] = useState([]);
  const [allMessages, setAllMessages] = useState([]);
  const [allEmails, setAllEmails] = useState([]);
  const [allCodes, setAllCodes] = useState([]);
  const [noCreators, setNoCreators] = useState(false)

  const [localSeen, setLocalSeen] = useState({});

  const [noUser, setNoUser] = useState(null);
  const [noSubscription, setNoSubscription] = useState(null);

  const [toast, setToast] = useState(null);

  const [inviteModalState, setInviteModalState] = useState({
    open: false,
    inviting: [],
    campaign: null,
    inviteType: null,
    isInitialInvite: false,
  });

  const [initialCreatorEmail, setInitialCreatorEmail] = useState(null);

  useEffect(() => {
    const unsub = auth.onAuthStateChanged(async () => {
      if (!authReady) {
        setAuthReady(true);
      }
    });

    // check url params for subscribed=true
    const urlParams = new URLSearchParams(window.location.search);
    if (urlParams.get('subscribed') === 'true') {
      window.gtag('event', 'conversion', {
        'send_to': 'AW-944196573/jKz7CMOUmYYCEN2XncID',
        'transaction_id': ''
      });
    }
    return unsub;
  }, [])

  const {
    data: user,
    refetch: refetchUser,
    error: userError,
    isLoading: userLoading,
  } = useQuery({
    queryKey: ['getUser'],
    queryFn: async () => {
      console.log('uid is', auth.currentUser?.uid)
      const user = await getDoc(doc(db, 'usersV2', auth.currentUser?.uid))
      if (!user.exists()) {
        setNoUser(true)
        window.gtag('event', 'conversion', { 'send_to': 'AW-944196573/FKZgCP37tJMCEN2XncID' });
        return null;
      }
      if (user && !user.data().fixedCredits && !user.data().credits) {
        window.Beacon('show-message', 'fece2d5b-72de-4f15-89ff-7200401d2c48')
      }
      setNoUser(false)
      return { ...user.data(), id: user.id }
    },
    enabled: !!authReady
  })

  console.log('user is', user, userError)

  const {
    data: subscriptions,
    refetch: refetchSubscription,
    error: subscriptionError,
    isLoading: subscriptionLoading,
  } = useQuery({
    queryKey: ['getSubscription'],
    queryFn: async () => {
      console.log('running')
      const subscriptionsRef = collection(db, `usersV2/${auth?.currentUser?.uid}/subscriptions`);
      const subscriptions = await getDocs(subscriptionsRef);
      if (subscriptions.empty) {
        setNoSubscription(true)
        window.Beacon('show-message', '15960ce7-5b79-435b-8230-8d6cede8d482')
      } else {
        setNoSubscription(false)
      }
      return subscriptions.docs.map((doc) => {
        return { ...doc.data(), id: doc.id }
      })
    },
    enabled: !!authReady
  })

  const {
    data: buckets,
    refetch: refetchBuckets,
  } = useQuery({
    queryKey: ['getBuckets'],
    queryFn: async () => {
      console.log('running')
      const bucketsRef = collection(db, `usersV2/${auth?.currentUser?.uid}/buckets`);
      const buckets = await getDocs(bucketsRef);
      return buckets.docs.map((doc) => {
        return { ...doc.data(), id: doc.id }
      })
    },
    enabled: !!authReady
  })

  console.log('home buckets', buckets)

  let {
    data: leads,
    refetch: refetchLeads,
    isLoading: leadsLoading,
  } = useQuery({
    queryKey: ['getCreators'],
    queryFn: async () => {
      const creatorsRef = collection(db, `usersV2/${auth?.currentUser?.uid}/creators`);
      const creators = await getDocs(creatorsRef);
      if (creators.empty) {
        setNoCreators(true)
      } else {
        setNoCreators(false)
      }
      return creators.docs.map((doc) => {
        return { ...doc.data(), id: doc.id }
      })
    },
    enabled: !!authReady
  })

  leads = leads?.map(lead => {
    return {
      ...lead,
      seen: localSeen[lead.id] || lead.seen
    }
  })

  async function saveCreator(creator) {
    console.log('saving creator', creator)
    const newCreator = await addDoc(collection(db, `usersV2/${auth?.currentUser?.uid}/creators`), {
      ...creator,
      addedByUser: auth.currentUser.uid,
      status: 'needsInvite',
      addedDate: new Date()?.toUTCString(),
      seen: false
    })

    return newCreator.id
  }

  async function createOrUpdateUser(fields) {
    if (!user) {
      setDoc(doc(db, 'usersV2', auth.currentUser.uid), {
        ...fields,
        email: auth.currentUser.email,
        fixedCredits: 10,
        joinDate: new Date()?.toUTCString(),
      })
    } else {
      setDoc(doc(db, 'usersV2', user.id), fields, { merge: true })
    }
    refetchUser()
  }

  const toastMarkup = toast ? (
    <Toast
      content={toast.content}
      error={toast.error}
      onDismiss={() => {
        setToast(null)
      }} />
  ) : null;

  const someLoading = userLoading || subscriptionLoading || leadsLoading;

  return (
    <PartnerUpContext.Provider value={{
      auth,
      db,
      someLoading,

      getModashProfile,
      saveCreator,

      user,
      noUser,
      createOrUpdateUser,

      subscriptions,
      noSubscription,

      leads,
      refetchLeads,
      localSeen,
      setLocalSeen,

      outreachInvites,
      deals,
      content,
      allCodes,
      allMessages,
      allEmails,

      buckets,
      refetchBuckets,

      initialCreatorEmail,
      setInitialCreatorEmail,

      // forms,
      inviteModalState,
      setInviteModalState,

      setToast,

      refetchUser,

    }}>
      <Frame>
        {toastMarkup}
        {children}
      </Frame>
    </PartnerUpContext.Provider>
  )
}
